import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { storeTransform } from "@redotech/util/store";
import { localStore } from "@redotech/web-util/storage";
import { memo } from "react";
import * as ordersCss from "./outbound-labels.module.css";

interface HideSlideoutCheckboxProps {
  hideSlideout: boolean;
  setHideSlideout: (hide: boolean) => void;
}

export const hideSlideoutStore = storeTransform(
  localStore("redo.fulfillment-group-page.hideSlideout"),
  {
    read: (value) => value === "true",
    write: (value) => (value ? "true" : undefined),
  },
);

export const HideSlideoutCheckbox = memo(function HideSlideoutCheckbox({
  hideSlideout,
  setHideSlideout,
}: HideSlideoutCheckboxProps) {
  return (
    <Flex className={ordersCss.hideSlideoutCheckbox}>
      <RedoCheckbox
        label="Hide slideout"
        setValue={setHideSlideout}
        size="sm"
        value={hideSlideout}
      />
    </Flex>
  );
});
